import AlertPopup from "components/alert-popup/AlertPopup";
import InfoContext from "pages/InfoContext";
import InfoHeaderAction from "pages/info-header/InfoHeaderAction";
import MissionsWorkers from "components/workers/MissionsWorkers";
import PersonalConsultant from "components/sections-consultant/PersonalConsultant";
import DashboardConsultant from "components/sections-consultant/dashboard/DashboardConsultant";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ROLE_CSE, ROLE_PLPM } from "constants/forms";
import { ENTITY } from "constants/info-header";
import { getStatusLabel } from "utils/workerHelper";
import { useBranchesContext } from "api/settings/branches/BranchesProvider";
import { useClientContext } from "api/directory/client/ClientProvider";
import { useConsultantContext } from "api/directory/consultant/ConsultantProvider";
import { useCurrencyContext } from "api/settings/currency/CurrencyProvider";
import { useDybContext } from "api/external-apis/dyb/DybProvider";
import { useContext, useEffect, useMemo, useState } from "react";
import { useExternalTrainingContext } from "api/datatrack/external-training/ExternalTrainingProvider";
import { useFileContext } from "api/files/FilesProvider";
import { useGeneralContext } from "api/directory/general/GeneralProvider";
import { useInternalTrainingContext } from "api/datatrack/internal-training/InternalTrainingProvider";
import { useJobContext } from "api/settings/job/JobProvider";
import { useMissionContext } from "api/mission/MissionProvider";
import LoaderV2 from "core/loader/LoaderV2";
import { usePersonContext } from "api/directory/person/PersonProvider";
import { useReasonLeaveContext } from "api/settings/reason-leave/ReasonLeaveProvider";
import { useRecruitmentMethodContext } from "api/settings/recruitment-method/RecruitmentMethodProviders";
import { useStaffContext } from "api/directory/staff/StaffProvider";
import { useSyntecContext } from "api/settings/syntec/SyntecProvider";
import { useUserContext } from "api/user/UserProvider";
import { useUserDatatrackContext } from "api/datatrack/UserDatatrackProvider";
import EvaluateModal from "components/modal/EvaluateModal";
import {
  formatCreatedData,
  getConsultantMissionStatus,
  getMissionStatusLabel,
} from "utils/consultantHelper";
import {
  QUERY_STATUS,
  SECTIONS,
  DATATRACK_MODELS,
  FILTERS,
  CONSULTANT_MISSION_STATUS,
  ACTIONS,
  DOCUMENTS_BASE_URL_BY_ENTITY,
  STAFF_PROFILES,
  FILTERS_FOR_NAMES,
} from "constants/constants";
import { getFormattedDate } from "utils/functions";
import { FormattedMessage } from "react-intl";
import { usePersonBalancesheetContext } from "api/balance-sheet/person/PersonBalancesheetProvider";
import _ from "lodash";
import PageContext from "pages/PageContext";
import { useWindowSize, useEntityProfilePicture } from "utils/customHooks";
import { useDomainContext } from "api/datatrack/domain/DomainProvider";
import { useNationalitiesContext } from "api/settings/nationalities/NationalitiesProvider";
import { useContractualStatusContext } from "api/settings/contractual-status/ContractualStatusProvider";
import ValidationModal from "components/modal/ValidationModal";
import DocumentDownloadModal from "components/modal/DocumentDownloadModal";
import { useDocumentsContext } from "api/documents/DocumentsProvider";
import {
  commonOnCloseHandler,
  validationModalTitleHelper,
} from "utils/modalsHelper";
import { statusHandler } from "utils/helper";
import { useMissionBalancesheetContext } from "api/balance-sheet/mission/MissionBalancesheetProvider";

const DisplayConsultant = () => {
  const navigate = useNavigate();
  const { mailMissionEvalStatus } = useMissionBalancesheetContext();
  const { slugSearched, setSlugSearched } = useContext(PageContext);
  const { lang, userScope, userRoleList, setApiErrorResponse } =
    useUserContext();
  const {
    getMissionsByWorkerId,
    getTimeline,
    resetTimeline,
    timelineMissionsList,
    timelineQueryStatus,
    timelineEntityId,
  } = useMissionContext();
  const { domainList, getDomainListByUserId } = useDomainContext();
  const { getInternalTrainingByUserId, internalTraining } =
    useInternalTrainingContext();
  const {
    getExternalTrainingByUserId,
    externalTraining,
    uploadExternalTrainingByUserId,
    progression,
    setProgression,
  } = useExternalTrainingContext();
  const { getClientsByIds, clientsByIds } = useClientContext();
  const { searchUsersByName, usersByName } = useDybContext();
  const {
    consultantBySlug,
    consultantUpdate,
    editConsultantStatus,
    setEditConsultantStatus,
    deleteConsultantStatus,
    setDeleteConsultantStatus,
    deleteConsultant,
    displayConsultantStatus,
    getConsultantBySlug,
    consultantById,
    apiErrorResponse,
    consultantSixYearsReview,
    getConsultantSixYearsReview,
  } = useConsultantContext();
  const {
    getAvailableDocuments,
    availableDocuments,
    getDocument,
    getDocumentStatus,
    setGetDocumentStatus,
    downloadReviewFile,
  } = useDocumentsContext();
  const { contractualStatusList, contractualStatusListGetter } =
    useContractualStatusContext();
  const { getPersonEvaluation, personEvaluations } =
    usePersonBalancesheetContext();
  const {
    currencyListGetter,
    currencyList,
    currencyListByBranch,
    currencyListByBranchGetter,
  } = useCurrencyContext();
  const { createdFile, setCreatedFile, createFile } = useFileContext();
  const { recruitmentMethodList, recruitmentMethodListGetter } =
    useRecruitmentMethodContext();
  const { jobList, jobListGetter } = useJobContext();
  const { personsList, getPersonsByIds, getPersonById, personById } =
    usePersonContext();
  const { syntecCoefListGetter, syntecCoefList } = useSyntecContext();
  const { searchUsers, usersByIds, getNamesByFilters, namesByFilters } =
    useGeneralContext();
  const { fetchBranches, branches } = useBranchesContext();
  const { reasonLeaveListGetter, reasonLeaveList } = useReasonLeaveContext();
  const {
    userDatatrackGetter,
    userDatatrack,
    userDatatrackCreate,
    userDatatrackDeleteById,
    userDatatrackStatus,
    filteredSatisfaction,
    getSatisfactionByFilter,
    filteredCorporateLife,
    getCorporateLifeByFilter,
  } = useUserDatatrackContext();
  const { getStaffByArrayId, staffByIds } = useStaffContext();
  const { nationalitiesList, nationalitiesListGetter } =
    useNationalitiesContext();
  const [readOnly, setReadOnly] = useState(true);
  const [section, setSection] = useState(SECTIONS.PERSONAL);
  const [isEnabled, setIsEnabled] = useState(false);
  const [missionStatus, setMissionStatus] = useState();
  const [openSalaryModal, setOpenSalaryModal] = useState(false);
  const [openManageExternalTrainingModal, setOpenManageExternalTrainingModal] =
    useState(false);
  const [isFromEvaluation, setIsFromEvaluation] = useState(false);
  const [code, setCode] = useState();
  const { picture: entityPicture } = useEntityProfilePicture(
    consultantBySlug?.picture_file_id
  );

  // Use createdFile as fallback when entity picture is not available
  const picture = createdFile?.deleted
    ? null
    : entityPicture || createdFile?.uri || createdFile?.picture_file_id;
  const [status, setStatus] = useState();
  const { slug } = useParams();
  const [refresh, setRefresh] = useState(false);
  const [id, setId] = useState();
  const [isOpenEvaluateModal, setIsOpenEvaluateModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [userCoefPosition, setUserCoefPosition] = useState([]);
  const [isVisa, setIsVisa] = useState(false);
  const [userGrossConventionalMimimum, setUserGrossConventionalMimimum] =
    useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const BASE_URL = DOCUMENTS_BASE_URL_BY_ENTITY.CONSULTANT;
  const size = useWindowSize();
  const csltSlug = slugSearched || slug;
  const isCurrentEntity = consultantBySlug?.slug === csltSlug;

  const [isCSE, setIsCSE] = useState(false);
  const [isPracticeLeader, setIsPracticeLeader] = useState(false);

  const currentQueryStatus = statusHandler({
    statusList: [editConsultantStatus, deleteConsultantStatus],
  });

  const validationModalTitle = validationModalTitleHelper({
    isEditAction: editConsultantStatus !== QUERY_STATUS.INITIAL,
    isDeleteAction: deleteConsultantStatus !== QUERY_STATUS.INITIAL,
  });

  const flattedsyntecCoefList = syntecCoefList?.flatMap((e) =>
    e.coef_position_syntec.map((elm) => ({ ...elm }))
  );

  const validationModalStatus = isFromEvaluation
    ? mailMissionEvalStatus
    : currentQueryStatus;

  const isDisabledCell = !readOnly && consultantBySlug ? "cell-disabled" : "";
  const [openModalIntent, setOpenModalIntent] = useState(null);

  useEffect(() => {
    if (!isFromEvaluation) return;

    if (mailMissionEvalStatus === QUERY_STATUS.SUCCESS) {
      setIsOpenEvaluateModal(false);
    }
  }, [mailMissionEvalStatus, isFromEvaluation]);

  const handlesendEvaluationMail = () => {
    setIsFromEvaluation(true);
    setIsOpen(true);
  };

  useEffect(() => {
    setApiErrorResponse(null);
  }, []);

  useEffect(() => {
    nationalitiesListGetter();
    contractualStatusListGetter();
  }, [lang]);

  useEffect(() => {
    setReadOnly(true);
    setCreatedFile({});
    !_.isNil(userScope) && csltSlug && getConsultantBySlug(csltSlug);
    refresh && setRefresh(false);
  }, [csltSlug, refresh, userScope]);

  useEffect(() => {
    if (displayConsultantStatus === QUERY_STATUS.NOT_FOUND) {
      navigate(`/${userScope}/not-found`, { replace: true });
    }
  }, [displayConsultantStatus, userScope, navigate]);

  useEffect(() => {
    if (userDatatrack?.coef?.length > 0) {
      const coefPosition = flattedsyntecCoefList?.find(
        (elm) => elm.id === userDatatrack.coef[0]?.syntec_coef_position
      );
      setUserCoefPosition([
        {
          label: coefPosition?.value,
          value: coefPosition?.id,
        },
      ]);
      setUserGrossConventionalMimimum(coefPosition?.gross_conventional_minimum);
    } else {
      setUserCoefPosition([]);
      setUserGrossConventionalMimimum(null);
    }
  }, [userDatatrack]);

  const openEvaluateModal = (item) => {
    setSelectedItem(item);
    setIsOpenEvaluateModal(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsOpenEvaluateModal(false);
  };

  useEffect(() => {
    if (section === SECTIONS.DASHBOARD && !_.isNil(userScope)) {
      getInternalTrainingByUserId({ id: consultantBySlug?.id });
      getExternalTrainingByUserId({ id: consultantBySlug?.id });
      getPersonEvaluation({ id: consultantBySlug?.id });

      if (consultantBySlug?.id) {
        getCorporateLifeByFilter({
          personId: consultantBySlug.id,
        });

        getSatisfactionByFilter({
          personId: consultantBySlug?.id,
        });
      }
    }
  }, [section, refresh]);

  useEffect(() => {
    setMissionStatus(getConsultantMissionStatus(consultantBySlug?.status));
  }, [timelineMissionsList, userDatatrack, consultantBySlug?.id]);

  useEffect(() => {
    const { id, gp_id, manager_id, referer_internal_id, visa, role } =
      consultantBySlug || {};

    setIsCSE(role?.includes(ROLE_CSE));
    setIsPracticeLeader(role?.includes(ROLE_PLPM));

    visa && setIsVisa(visa);

    if (consultantBySlug && !_.isNil(userScope)) {
      const ids = [gp_id, manager_id, referer_internal_id].filter(Boolean);
      ids?.length &&
        getNamesByFilters({
          id: ids,
          types: [FILTERS_FOR_NAMES.PERSON],
          include_deleted: true,
        });
    }

    resetTimeline();

    if (id) {
      getTimeline({ filters: { type: "cslt_str", id } });
      getMissionsByWorkerId({ id });
      getDomainListByUserId({ id });
      getAvailableDocuments({
        entityId: id,
        BASE_URL,
      });
      getConsultantSixYearsReview({ id });
      setId(id);
    }

    setSlugSearched("");
  }, [consultantBySlug]);

  const models = [
    DATATRACK_MODELS.cl,
    DATATRACK_MODELS.CONTRACT,
    DATATRACK_MODELS.MANAGER,
    DATATRACK_MODELS.POS_COEF,
    DATATRACK_MODELS.JOB_HISTORY,
    DATATRACK_MODELS.INTERNAL_TRAINING_COMMENTS,
    DATATRACK_MODELS.DASHBOARD_COMMENTS,
    DATATRACK_MODELS.SALARY,
  ];

  const getUserDatatrack = ({ id }) =>
    id &&
    models.map((model) =>
      userDatatrackGetter({
        id,
        model,
      })
    );

  useEffect(() => {
    recruitmentMethodListGetter();
    fetchBranches();
    jobListGetter(FILTERS.CSLT);
    reasonLeaveListGetter();
    syntecCoefListGetter();
    currencyListGetter();
    getUserDatatrack({ id: consultantBySlug?.id });
  }, [id, refresh]);

  const getOptions = (search) => {
    getNamesByFilters({
      profile: [...STAFF_PROFILES, "cslt", "str"],
      types: [FILTERS_FOR_NAMES.PERSON],
      search,
    });
  };

  const updateData = async (info) => {
    const formattedData = formatCreatedData(info, {
      contractualStatusList,
      flattedsyntecCoefList,
    });

    window.scrollTo(0, 0);
    // Awaited so the caller's submit lock covers the whole request
    await consultantUpdate(consultantBySlug?.id, formattedData);
  };

  const onSubmit = async (info) => {
    await updateData({
      ...info,
      picture_file_id: createdFile?.deleted
        ? null
        : createdFile?.picture_file_id ||
          createdFile?.uri ||
          consultantBySlug?.picture_file_id,
      enabled: isEnabled,
      role: [
        ...(isCSE ? [ROLE_CSE] : []),
        ...(isPracticeLeader ? [ROLE_PLPM] : []),
      ],
    });
  };

  const commentAction = ({ action, content, commentId, model }) => {
    if (action === ACTIONS.CREATE) {
      userDatatrackCreate({
        data: { person_id: consultantBySlug?.id, content },
        model,
      });
    } else if (action === ACTIONS.DELETE)
      userDatatrackDeleteById({
        model,
        id: commentId,
      });
  };

  const initHeader = () => {
    setIsEnabled(consultantBySlug.enabled);
  };

  const getPersonsList = (ids) => {
    getPersonsByIds({ ids });
  };

  useEffect(() => {
    if (!_.isEmpty(personEvaluations?.mission_evaluations)) {
      const clientsIds = personEvaluations?.mission_evaluations
        .map((elm) => elm.client_id)
        .join(",");
      getClientsByIds({ ids: clientsIds });
    }
  }, [personEvaluations]);

  useEffect(() => {
    currentQueryStatus !== QUERY_STATUS.INITIAL && setIsOpen(true);
    if (editConsultantStatus === QUERY_STATUS.SUCCESS) {
      getConsultantBySlug(consultantBySlug?.slug);
    }
  }, [currentQueryStatus]);

  const getPersonsByName = (search) => {
    searchUsersByName({ search });
  };

  const getFormattedMission = (list) =>
    list?.map((elm) => ({
      name: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {elm?.mission_name || getMissionStatusLabel(elm?.worker_status)}
          <br />
          {elm?.mission_analytical_code || elm?.worker_analytical_code}
        </div>
      ),
      client_id:
        elm?.client_name === null ? (
          <div style={{ textAlign: "center" }}>-</div>
        ) : (
          <Link to={`/${userScope}/client/${elm.client_id && elm.client_slug}`}>
            {elm.client_name}
          </Link>
        ),
      manager_id: (
        <Link
          to={`/${userScope}/staff/${elm?.manager_slug}`}
          onClick={() => setSlugSearched(elm?.manager_slug)}
        >
          {elm?.manager_name || "-"}
        </Link>
      ),
      start_date: getFormattedDate(elm?.start_date, lang),
      end_date: (
        <div style={{ textAlign: "center" }}>
          {elm?.end_date ? getFormattedDate(elm?.end_date, lang) : "-"}
        </div>
      ),

      status: (
        <div className="status_column">
          {elm?.worker_status === CONSULTANT_MISSION_STATUS.ZERO
            ? getStatusLabel(elm?.mission_status)
            : getStatusLabel(elm?.worker_status)}
          {elm?.mission_slug && (
            <div className="links">
              <div className="div-link">
                <Link to={`/${userScope}/missions/${elm?.mission_slug}`}>
                  <FormattedMessage
                    id="view_sheet"
                    defaultMessage={"Voir la fiche"}
                  />
                </Link>
              </div>
              {elm.evaluate && (
                <button
                  className="div-link evaluate-link"
                  onClick={() => openEvaluateModal(elm)}
                >
                  <FormattedMessage
                    id="evaluate_mission_modal"
                    defaultMessage={"Évaluer"}
                  />
                </button>
              )}
            </div>
          )}
        </div>
      ),
      name_for_search: [
        elm?.mission_name,
        elm?.client_name,
        elm?.mission_analytical_code,
        elm?.worker_analytical_code,
      ]
        .filter(Boolean)
        .join(" "),
    }));

  const value = useMemo(
    () => ({
      filteredSatisfaction,
      getSatisfactionByFilter,
      filteredCorporateLife,
      getCorporateLifeByFilter,
      apiErrorResponse,
      consultantById,
      nationalities: nationalitiesList,
      setStatus,
      setCode,
      branches: branches,
      clientsByIds,
      consultantBySlug,
      currencyList: currencyList,
      davFunctions: jobList,
      deleted: consultantBySlug?.email?.includes("DELETED"),
      entity: ENTITY.CONSULTANT,
      externalTraining: externalTraining,
      uploadExternalTrainingByUserId,
      progression,
      setProgression,
      getOptions: getOptions,
      getPersonById: getPersonById,
      getPersonsByName: getPersonsByName,
      getPersonsList: getPersonsList,
      getStaffByArrayId: getStaffByArrayId,
      id: consultantBySlug?.id,
      internalTraining: internalTraining,
      isEnabled: isEnabled,
      lang: lang,
      leavingReasons: reasonLeaveList,
      managersList: [],
      missionStatus: missionStatus,
      onDelete: deleteConsultant,
      openSalaryModal: openSalaryModal,
      personById: personById,
      personEvaluations: personEvaluations,
      personsList: personsList,
      personsByProfileList: namesByFilters,
      readOnly: readOnly,
      recruitmentMethodList: recruitmentMethodList,
      searchUsers: searchUsers,
      section: section,
      setIsEnabled: setIsEnabled,
      setOpenSalaryModal: setOpenSalaryModal,
      openManageExternalTrainingModal,
      setOpenManageExternalTrainingModal,
      setReadOnly: setReadOnly,
      setSection: setSection,
      staffByIds: staffByIds,
      syntecCoef: flattedsyntecCoefList,
      usersByIds: namesByFilters,
      usersByName: usersByName,
      userScope: userScope,
      userById: consultantBySlug,
      setRefresh: setRefresh,
      refresh,
      isMobile: size.width < 600,
      domainList,
      contractualStatusList,
      userCoefPosition,
      userGrossConventionalMimimum,
      createFile,
      createdFile,
      setCreatedFile,
      picture,
      internalTrainingComments: userDatatrack?.internal_training_comments || [],
      dashboardComments: userDatatrack?.dashboard_comment || [],
      currencyListByBranch,
      currencyListByBranchGetter,
      editConsultantStatus,
      entityStatus: userDatatrackStatus,
      entitySlug: consultantBySlug?.slug,
      availableDocuments,
      getDocument,
      getDocumentStatus,
      BASE_URL,
      isValidationModalOpen: isOpen,
      commentAction,
      userRoleList,
      getNamesByFilters,
      isVisa,
      isDisabledCell,
      isCSE,
      setIsCSE,
      isPracticeLeader,
      setIsPracticeLeader,
      slug,
      openModalIntent,
      setOpenModalIntent,
    }),
    [
      filteredSatisfaction,
      filteredCorporateLife,
      apiErrorResponse,
      consultantById,
      editConsultantStatus,
      nationalitiesList,
      consultantBySlug,
      currencyList,
      externalTraining,
      uploadExternalTrainingByUserId,
      progression,
      setProgression,
      id,
      internalTraining,
      isEnabled,
      jobList,
      lang,
      missionStatus,
      openSalaryModal,
      personById,
      personsList,
      readOnly,
      reasonLeaveList,
      recruitmentMethodList,
      section,
      staffByIds,
      flattedsyntecCoefList,
      usersByIds,
      personEvaluations,
      usersByName,
      userScope,
      consultantBySlug,
      refresh,
      domainList,
      contractualStatusList,
      userCoefPosition,
      userGrossConventionalMimimum,
      namesByFilters,
      createFile,
      createdFile,
      setCreatedFile,
      picture,
      openManageExternalTrainingModal,
      userDatatrack?.internal_training_comments,
      userDatatrack?.dashboard_comment,
      currencyListByBranch,
      currencyListByBranchGetter,
      availableDocuments,
      getDocument,
      BASE_URL,
      userDatatrackStatus,
      isOpen,
      commentAction,
      userRoleList,
      getNamesByFilters,
      isVisa,
      isDisabledCell,
      isCSE,
      setIsCSE,
      isPracticeLeader,
      setIsPracticeLeader,
      slug,
      openModalIntent,
    ]
  );

  return (
    <InfoContext.Provider value={value}>
      <AlertPopup
        code={code}
        setCode={setCode}
        setStatus={setStatus}
        status={status}
      />
      <DocumentDownloadModal
        status={getDocumentStatus}
        onClose={() => setGetDocumentStatus(QUERY_STATUS.INITIAL)}
      />
      <ValidationModal
        open={isOpen}
        status={validationModalStatus}
        onClose={() => {
          setIsFromEvaluation(false);

          commonOnCloseHandler({
            editEntityStatus: editConsultantStatus,
            deleteEntityStatus: deleteConsultantStatus,
            setDeleteEntityStatus: setDeleteConsultantStatus,
            setEditEntityStatus: setEditConsultantStatus,
            setIsOpen,
            setReadOnly,
            userScope,
            navigate,
          });
        }}
        messages={{
          pendingTitleId: validationModalTitle,
          pendingMessageId: "modal_validation_file_pending_msg",
          successTitleId: validationModalTitle,
          successMessageId: "modal_validation_file_success_msg",
          errorTitleId: validationModalTitle,
          errorMessageId: "modal_validation_field_errors_msg",
          errorMessageDefault:
            "Certains champs comportent des erreurs.{br}Veuillez cliquer sur les icônes : <nowrap>{errorIcon}</nowrap> pour obtenir plus de détails et corriger les informations nécessaires.",
        }}
      />
      {(!isCurrentEntity ||
        ![
          QUERY_STATUS.SUCCESS,
          QUERY_STATUS.ERROR,
          QUERY_STATUS.NOT_FOUND,
        ].includes(displayConsultantStatus)) && (
        <LoaderV2 loaderSize="fullpage" />
      )}
      {isCurrentEntity && displayConsultantStatus === QUERY_STATUS.SUCCESS && (
        <>
          <InfoHeaderAction />
          {section === SECTIONS.PERSONAL && (
            <PersonalConsultant
              readOnly={readOnly}
              setReadOnly={setReadOnly}
              onSubmit={onSubmit}
              initHeader={initHeader}
              getStatus={setStatus}
              getCode={setCode}
              status={status}
              code={code}
            />
          )}
          {section === SECTIONS.MISSIONS &&
            (timelineEntityId !== consultantBySlug?.id ||
              timelineQueryStatus === QUERY_STATUS.LOADING) && (
              <LoaderV2 loaderSize="fullpage" />
            )}
          {section === SECTIONS.MISSIONS &&
            timelineEntityId === consultantBySlug?.id &&
            timelineQueryStatus === QUERY_STATUS.SUCCESS && (
              <MissionsWorkers
                formattedMissions={getFormattedMission(timelineMissionsList)}
                role={ENTITY.CONSULTANT}
                workers={personsList}
                clients={clientsByIds}
                id="missionsConsultant"
              />
            )}
          {section === SECTIONS.DASHBOARD && (
            <DashboardConsultant
              readOnly={readOnly}
              userScope={userScope}
              consultantBySlug={consultantBySlug}
              consultantSixYearsReview={consultantSixYearsReview}
              personEvaluations={personEvaluations}
              filteredCorporateLife={filteredCorporateLife}
              downloadReviewFile={downloadReviewFile}
            />
          )}
          {isOpenEvaluateModal && (
            <EvaluateModal
              open={isOpenEvaluateModal}
              onClose={closeModal}
              item={selectedItem}
              sendEvaluationMail={handlesendEvaluationMail}
            />
          )}
        </>
      )}
    </InfoContext.Provider>
  );
};

export default DisplayConsultant;
